import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { setConfig } from 'react-hot-loader';
import * as Raven from 'raven-js';
import { AppWindow, ReactAppParams } from './window';

const appConfig: ReactAppParams = (window as any as AppWindow).appConfig;

declare var __DEV__: boolean;

// Logování
if (appConfig && appConfig.sentry && (!__DEV__ || appConfig.sentry.force)) {
    let url = window.location.protocol + '//' + window.location.host + appConfig.serverContextPath + '/log';
    let options = {release: appConfig.version + (appConfig.buildNumber || '')};
    if (appConfig.sentry) {
        if (appConfig.sentry.url) {
            url = appConfig.sentry.url;
        }
        if (appConfig.sentry.options) {
            options = {...appConfig.sentry.options, ...options};
        }
    }
    Raven.config(url, options).install();
}

import { hotApp as App } from './App';

// TODO .env react.hot.debug:true
if (__DEV__) {
    setConfig({ logLevel: 'debug' }); // TODO .env react.hot.debug.level || 'debug'
}

// TODO store
import { default as store } from './store/index';

export function render(elementId: string = 'root') {
    ReactDOM.render(<App store={store} />, document.getElementById(elementId));
}
